module.exports = __webpack_public_path__ + "static/media/For-You-Active.4cc1bc71.svg";